import { RecipientContainer } from 'owa-link-data';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import { SharingTipRecipientInfo } from 'owa-sharing-data';
import { action } from 'satcheljs';

export const tryCheckPermForLinks = action(
    'TRY_CHECK_PERM_FOR_LINKS',
    (linkIds: string[], recipientInfos: SharingTipRecipientInfo[], composeId: string) => ({
        linkIds: linkIds,
        recipientInfos: recipientInfos,
        composeId: composeId,
    })
);

export const expandGroupsAndSmallDLs = action(
    'EXPAND_GROUPS_AND_SMALL_DLS',
    (linkIds: string[], recipientInfos: SharingTipRecipientInfo[], composeId: string) => ({
        linkIds: linkIds,
        recipientInfos: recipientInfos,
        composeId: composeId,
    })
);

export const tryCheckPermForOneLink = action(
    'TRY_CHECK_PERM_FOR_ONE_LINK',
    (
        linkId: string,
        recipientContainers: RecipientContainer[],
        fromAddress: string,
        composeId: string
    ) => ({
        linkId: linkId,
        recipientContainers: recipientContainers,
        fromAddress: fromAddress,
        composeId: composeId,
    })
);

export const composeGetHasSharingIssues = action(
    'COMPOSE_GET_HAS_SHARING_ISSUES',
    (composeId: string) => ({
        composeId: composeId,
    })
);

export const onLinkHasChanged = action(
    'ON_LINK_PERMISSION_CHANGED',
    (
        linkId: string,
        newPermissionLevel: AttachmentPermissionLevel,
        recipientInfos: SharingTipRecipientInfo[],
        composeId: string
    ) => ({
        linkId: linkId,
        newPermissionLevel: newPermissionLevel,
        recipientInfos: recipientInfos,
        composeId: composeId,
    })
);
